export default __webpack_public_path__ + "static/media/kit_2.9fa6e62f.png";